import queryString from 'query-string'
import axiosApiInstance from '@/api/axios'
import { AxiosResponse } from 'axios'
import {
  CompanystatisticModel,
  FiltersCollectionModel,
  LicensesCollectionModel,
  LicensesModel,
  NewLicenseModel,
  SerialNumberRequestModel,
  SyncCompanyListModel,
  SyncExternalServiceModel,
  SyncLicenseModel,
  SyncResellersModel,
} from './models/LicensesModel'
import { CustomerModel } from './models/LicensesModel'
import { DateFilterModel } from '@/core/interfaces/data-filter'
import { LICENSES_ENDPOINTS } from './api/api'
import { TRANSACTIONS_FILE_TYPE } from './constants'

class LicensesService {
  async getLicenses(data: FiltersCollectionModel): Promise<LicensesModel> {
    const res = await axiosApiInstance.post(`/Licenses/byFilter`, data)

    return res.data
  }

  async syncLicense(data: SyncLicenseModel): Promise<AxiosResponse> {
    const res = await axiosApiInstance.post(`/Licenses/syncmanager`, data)

    return res.data
  }

  async syncResellers(data: SyncResellersModel): Promise<AxiosResponse> {
    const res = await axiosApiInstance.post(
      `/Resellers/syncmanager/resellers`,
      data,
    )

    return res.data
  }

  async syncExternalService(
    data: SyncExternalServiceModel,
  ): Promise<AxiosResponse> {
    const res = await axiosApiInstance.post(
      `/Licenses/syncmanager/companies`,
      data,
    )

    return res.data
  }

  async syncCompanyList(data: SyncCompanyListModel): Promise<AxiosResponse> {
    const res = await axiosApiInstance.post(
      `/Licenses/syncmanager/licenses`,
      data,
    )

    return res.data
  }

  async updateLicense(
    data: CustomerModel & { id: string },
  ): Promise<LicensesModel> {
    const { id, ...customer } = data
    const res = await axiosApiInstance.patch(`/Licenses/${id}`, customer)

    return res.data
  }

  async licensesByCompanyCode(
    companyCode: string,
  ): Promise<LicensesCollectionModel> {
    const res = await axiosApiInstance.post(
      `/Licenses/byCompanyCode/${companyCode}`,
    )

    return res.data
  }

  async licensesReassignReseller(licenseId: string): Promise<AxiosResponse> {
    const res = await axiosApiInstance.put(
      `Licenses/reassign-reseller?licenseId=${licenseId}&resellerId=DG`,
    )
    return res.data
  }

  async licensesReassignCustomReseller(params: {
    licenseId: string
    resellerId: string
  }): Promise<LicensesModel> {
    const query = queryString.stringify(params)
    const res = await axiosApiInstance.put(
      `${LICENSES_ENDPOINTS.REASSIGN_RESELLER}/?${query}`,
    )

    return res.data
  }

  async licensesSerialNumber(
    data: SerialNumberRequestModel,
  ): Promise<LicensesModel> {
    const res = await axiosApiInstance.post(`/Licenses/serialNumber`, data)

    return res.data
  }

  async licensesTrialByDeviceSerial(
    data: NewLicenseModel,
  ): Promise<LicensesCollectionModel> {
    const res = await axiosApiInstance.post(
      `/Licenses/trial/byDeviceSerial`,
      data,
    )

    return res.data
  }

  async licensesFreeByDiscountCode(
    data: NewLicenseModel,
  ): Promise<LicensesCollectionModel> {
    const res = await axiosApiInstance.post(
      `/Licenses/free/byDiscountCode`,
      data,
    )

    return res.data
  }

  async getCompanystatistic({
    startDate,
    endDate,
  }: DateFilterModel): Promise<CompanystatisticModel[]> {
    const res = await axiosApiInstance.get(
      `/insights/companystatistic?fromDate=${startDate}&toDate=${endDate}`,
    )

    return res.data
  }

  async getTransactions({
    startDate,
    endDate,
    isIncludeExpired,
    isIncludeDeleted,
  }: DateFilterModel & {
    isIncludeExpired: boolean
    isIncludeDeleted: boolean
  }): Promise<string> {
    const res = await axiosApiInstance.get(
      LICENSES_ENDPOINTS.TRANSACTIONS_EXPORT,
      {
        headers: {
          'Content-Type': TRANSACTIONS_FILE_TYPE,
        },
        responseType: 'blob',
        params: {
          fromDate: startDate,
          toDate: endDate,
          includeExpired: isIncludeExpired,
          includeDeleted: isIncludeDeleted,
        },
      },
    )
    return res.data
  }

  // async getTransactions(): Promise<string> {
  //   const res = await axiosApiInstance.get(`/insights/transactions/export`, {
  //     headers: {
  //       'Content-Type':
  //         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //     },
  //     responseType: 'blob',
  //   })
  //   return res.data
  // }
}

export default new LicensesService()
